import type { BreakpointsOptions } from "@mui/material/styles";

export const breakpointsOptions: BreakpointsOptions & {
  values: NonNullable<BreakpointsOptions["values"]>;
} = {
  values: {
    xs: 0,
    xsm: 330,
    sm: 600,
    md: 800,
    lg: 1100,
    xl: 1600,
  },
};
